import { render, staticRenderFns } from "./ViewOrderList.vue?vue&type=template&id=1008e290&"
import script from "./ViewOrderList.vue?vue&type=script&lang=ts&"
export * from "./ViewOrderList.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports